import React, {PureComponent} from 'react'
import {getModalsBySlug} from '../../services/reservoir'
import parse from 'html-react-parser';
import Modal from './Modal'

class DrupalModal extends PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      title: '',
      content: ''
    }
  }

  componentDidMount() {
    this.loadModal(this.props)
  }

  componentDidUpdate(prevProps) {
    if (this.props.slug !== prevProps.slug) {
      this.loadModal(this.props)
    }
  }

  loadModal = props => {
    getModalsBySlug(props.slug)
      .then(modals => modals.data)
      .then(modals => {
        if (modals.length > 0) {
          const modal = modals[0]

          this.setState({
            title: modal.attributes.title,
            content: modal.attributes.body.value
          })
        }
      })
  }

  render () {
    return (
      <Modal
        className={`modal ${this.props.className}`}
        isOpen={this.props.isOpen}
        handleCloseModal={() => this.props.handleCloseModal()}
        title={this.state.title}
      >
        {parse(this.state.content)}
      </Modal>
    )
  }
}

export default DrupalModal
